import React from 'react';
import { IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonPage, IonRow, IonSpinner, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import './Friends.css';
import { Button } from 'primereact/button';
import { withRouter } from 'react-router';
import { InputText } from 'primereact/inputtext'
import { personOutline, personAddOutline } from 'ionicons/icons';
import { confirmPopup } from 'primereact/confirmpopup';
import { getJson, postJson } from '../fetchFunctions';
import { GetResult, Storage } from '@capacitor/storage';
import { error, success } from '../components/ToastController';
import { alertDelete } from '../components/DialogController';
import styled from 'styled-components';

export class Friends extends React.Component<any, any> {

	private bodyRef: any;
	private static refreshIntervalId: any;

	public static stopRefreshing(): void {
		if(Friends.refreshIntervalId)
			clearInterval(Friends.refreshIntervalId);
	}

	constructor(props: any) {
		super(props);

		this.state = {
			loading: true,
			privateKey: "",
			publicKey: "",
			friends: [],
			friendRequests: []
		}
		this.bodyRef = React.createRef();
	}

	ionViewWillEnter() {
		this.setState({loading: true})
		Storage.get({ key: "clientId" }).then((result: GetResult) => {
			this.setState({privateKey: result.value})
		})
		Storage.get({key: "publicKey"}).then((result: GetResult) => {
			this.setState({publicKey: result.value}, async () => {
				await this.fetchFriends();
				await this.fetchFriendRequests();
				this.setState({loading: false})
			})
		})
		//Stops any previous refreshers
		Friends.stopRefreshing();
		Friends.refreshIntervalId = setInterval(() => {
			if(this.state.publicKey && this.state.publicKey.length > 0) {
				this.fetchFriends();
				this.fetchFriendRequests();
			}
		}, 2000);
		
	}

	ionViewDidLeave() {

		Friends.stopRefreshing();
	}

	fetchFriends = async () => {
		getJson("friends/" + this.state.publicKey).then(response => {
			if(response.ok) {
				response.json().then((friends: any) => {
					this.setState({friends: friends})
				})
			}
			else if(response.status > 0) response.text().then((text: any) => error("[fetch friends] error code " + response.status + ", msg: " + text));
		})
	}

	fetchFriendRequests = async () => {
		getJson("friendRequests/" + this.state.publicKey).then(response => {
			if(response.ok) {
				response.json().then((requests: any) => {
					this.setState({friendRequests: requests})
				})
			}
			else if(response.status > 0) response.text().then((text: any) => error("[fetch friend requests] error code " + response.status + ", msg: " + text));
		})
	}

	removeFriend = (e: any, friend: any) => {

		alertDelete("Fjern ven", "Er du sikker på at du vil fjerne " + friend?.name + " som ven?", () => {
			let friends = this.state.friends;
			let friendToEdit = friends.find((f: any) => f.publicKey === friend.publicKey);
			if (friendToEdit) {
				friendToEdit.removingFriend = true;
				console.log(friend);

				postJson("friends/deleteFriend", {
					privateKey: this.state.privateKey,
					friendPublicKey: friend.publicKey
				}).then(response => {
					if(!response.ok && response.status > 0)
						response.text().then((text: any) => error("[remove friend] error code " + response.status + ", msg: " + text));
					this.fetchFriends();
				})
			}
		})
	}

	acceptFriendRequest = (request: any) => {
		let requests = this.state.friendRequests;
		let existingRequest = requests.find((r: any) => r.id === request.id);
		if(existingRequest)
		{
			existingRequest.accepting = true;
			this.setState({friendRequests: requests})
		}
		console.log(request)
		//TODO fetch request to remove friend request
		postJson("friends/acceptRequest", {
			privateKey: this.state.privateKey,
			friendPublicKey: request.publicKey
		}).then(response => {
			if(!response.ok && response.status > 0)
				response.text().then((text: any) => error("[accept friend request] error code " + response.status + ", msg: " + text));
			this.fetchFriends();
			this.fetchFriendRequests();
		})
	}

	removeFriendRequest = (e: any, request: any) => {
		let requests = this.state.friendRequests;
		let existingRequest = requests.find((r: any) => r.id === request.id);
		if(existingRequest)
		{
			existingRequest.removing = true;
			this.setState({friendRequests: requests})
		}
		//TODO fetch request to remove friend request
		postJson("friends/deleteRequest", {
			privateKey: this.state.privateKey,
			friendPublicKey: request.publicKey
		}).then(response => {
			if(!response.ok && response.status > 0)
				response.text().then((text: any) => error("[remove friend request] error code " + response.status + ", msg: " + text));
			this.fetchFriendRequests();
		})
	}

	goToSearch = () => {
		this.props.history.push("/search");
	}

	goToFriend = (friend: any) => {
		this.props.history.push("/app/user?id=" + friend.publicKey)
	}

	render() {
		return (
			<IonPage>
				<IonHeader>
					<IonToolbar>
						<IonTitle>Venner</IonTitle>
						<IonButtons slot="end">
							<Button onClick={this.goToSearch} label="Tilføj ny ven" icon="pi pi-user-plus" iconPos="left" className="p-button-primary" />
						</IonButtons>
					</IonToolbar>
				</IonHeader>
				<IonContent fullscreen ref={this.bodyRef}>
					<IonHeader collapse="condense">
						<IonToolbar>
							<IonTitle size="large">Venner</IonTitle>
						</IonToolbar>
					</IonHeader>
					{this.state.loading ?
						<div style={{ display: "flex", height: "100vh", justifyContent: "center", alignItems: "center" }}>
							<IonSpinner style={{ width: "10vw", height: "10vw" }} color="tertiary" name="lines-sharp" />
						</div>
					:
						<div style={{ marginTop: "16px" }}>
							<IonGrid>
								{this.state.friends.map((friend: any) => (
									<FriendRow key={friend.publicKey} style={{ display: "flex", alignItems: "center", userSelect: "none" }}>
										<IonCol size="10" onClick={() => this.goToFriend(friend)} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
											<IonIcon icon={personOutline} style={{ fontSize: "30px", marginRight: "20px" }} />
											<h3 style={{ display: "inline-block" }}>{friend.name}</h3>
										</IonCol>
										<IonCol size="2" style={{ display: "inline-block" }}>
											<Button onClick={(e: any) => this.removeFriend(e, friend)} icon="pi pi-trash" loading={friend.removingFriend} className="p-button-danger p-button-text p-button-lg" />
										</IonCol>
									</FriendRow >
								))}
								{this.state.friends.length === 0 && 
									<p>Du har ingen venner</p>
								}
							</IonGrid>
							{this.state.friendRequests.length > 0 &&
								<div>
									<h1 style={{ marginTop: "30px" }}>Venne anmodninger</h1>
									<IonGrid>
										{this.state.friendRequests.map((request: any) => (
											<IonRow key={request.publicKey} style={{ display: "flex", alignItems: "center" }}>
												<IonCol size="8" style={{ display: "flex", alignItems: "center" }}>
													<IonIcon icon={personOutline} style={{ fontSize: "30px", marginRight: "20px" }} />
													<h5 style={{ display: "inline-block" }}>{request.name}</h5>
												</IonCol>
												<IonCol size="2" style={{ display: "flex", alignItems: "center" }}>
													<Button onClick={() => this.acceptFriendRequest(request)} icon="pi pi-check" iconPos="left" loading={request.accepting} className="p-button-primary p-button-rounded" />
												</IonCol>
												<IonCol size="2" style={{ display: "inline-block" }}>
													<Button onClick={(e: any) => this.removeFriendRequest(e, request)} icon="pi pi-trash" loading={request.removing} className="p-button-danger p-button-text p-button-lg" />
												</IonCol>
											</IonRow>
										))}
									</IonGrid>
								</div>
							}
						</div>
					}
				</IonContent>
			</IonPage>
		)
	}
}

const FriendRow = styled(IonRow)`
	border-radius: 4px;
	&:hover {
		background-color: rgba(0, 0, 0, 0.03);
	}
`;

export default withRouter(withIonLifeCycle(Friends));
